<template>
  <div>
    <div class="md:mr-8">
      <div class="lg:max-w-full lg:flex bg-gray rounded mt-4">
        <div class="lg:h-auto lg:w-48 flex-none text-center overflow-hidden" v-if="franchiseeImageSrc">
          <img loading="lazy" :src="franchiseeImageSrc" class="rounded mx-auto franchiseImg" alt="local professional"/>
        </div>
        <div class="text-center mx-auto">
          <div class="px-4 pt-4 pb-2">
            <h3 class="meet ">Meet your local {{ location }} Professional</h3>
            <p class="signature">{{ name }}</p>
            <p class="text-base font-bold text-center m-0" v-if="phone">
              <a class="blue" :href="getPhoneHref(phone) ?? undefined">{{ displayPhone(phone) }}</a>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-gray {
  background-color: #eef1f4;
}

.meet {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* or 122% */
  text-align: center;
  letter-spacing: -0.665px;

  /* ADA grey */
  color: #517185;
}

</style>

<script>
import { formatPhoneNumber, getPhoneHref } from "~/utils/phone";

export default {
  props: [
    "name",
    "signatureImageSrc",
    "franchiseeImageSrc",
    "location",
    "phone"
  ],
  computed: {
    cssProps() {
      return {
        "--background-image": 'url("' + this.franchiseeImageSrc + '")',
        "--webkit-border-radius": "50px;",
        "--moz-border-radius": "50px;",
        "--border-radius": "50px;"
      };
    }
  },
  methods: {
    displayPhone(value) {
      return formatPhoneNumber(value) ?? value;
    },
    getPhoneHref(value) {
      return getPhoneHref(value);
    },
  }
};
</script>
